import { render, staticRenderFns } from "./CongratulationsRisingStar.vue?vue&type=template&id=64611f6c&scoped=true"
import script from "./CongratulationsRisingStar.vue?vue&type=script&lang=js"
export * from "./CongratulationsRisingStar.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsRisingStar.vue?vue&type=style&index=0&id=64611f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64611f6c",
  null
  
)

export default component.exports